var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg054Message(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H5C3.3 3 2 4.3 2 6V18C2 19.7 3.3 21 5 21H19C20.7 21 22 19.7 22 18V6C22 4.3 20.7 3 19 3ZM19 5C19.2 5 19.3 5.1 19.4 5.1L12 12.6L4.5 5.1C4.7 5.1 4.8 5 5 5H19ZM20 18C20 18.6 19.6 19 19 19H5C4.4 19 4 18.6 4 18V7.4L11.3 14.7C11.7 15.1 12.3 15.1 12.7 14.7L20 7.4V18Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg054Message);
export default __webpack_public_path__ + "static/media/054-message.454634cbb94e1d7e4ef64046eabcd5fa.svg";
export { ForwardRef as ReactComponent };